import React, { Fragment } from 'react'
import AsyncSelect from '../../../components/AsyncSelect'
import { Label } from '../../../components'
import SelectionQuery from './querydropdown'
import { getKeyOfOpt, lookupOption, renderOptionList } from './optionUtils'

const DropDown = ({
  id,
  name,
  label,
  helpText,
  searchable,
  isList,
  value,
  context,
  rtOptions,
  optionQuery,
  optFields,
  onChange,
  optionKeyName,
  getOptionTextFn,
  isInsideModal,
}) => {
  /*
    Translate val (the current value of the selection variable, as far as the UI control/component is concerned)
    into the actual value to be saved in the data context.
  */
  const localChange = (val) => {
    return lookupOption(val, rtOptions)
  }

  if (optionQuery) { // it's a query; options must be fetched async from the server
    return (
      <SelectionQuery id={id}
                      name={name}
                      label={label}
                      helpText={helpText}
                      value={value}
                      context={context}
                      query={optionQuery}
                      optFields={optFields}
                      onChange={onChange}
                      getKeyOfOpt={getKeyOfOpt}
                      optionKeyName={optionKeyName}
                      isInsideModal={isInsideModal}
      />
    )
  }
  // else we assume options are synchronously available, if there are any at all

  const varDef = context.getVarDef(name)
  const isListVar = varDef && varDef.isList
  const useAsync = isListVar || !Array.isArray(rtOptions)

  let optionList
  if (Array.isArray(rtOptions)) { // if options are synchronously available
    optionList = renderOptionList(rtOptions, !useAsync, context,
      (opt, scope) => {
        const optKey = getKeyOfOpt(opt, optionKeyName)
        if (useAsync) {
          return {
            value: optKey,
            label: optKey && getOptionTextFn(opt, scope),
          }
        } else {
          return (
            <option key={id + '|' + optKey} value={optKey}>{optKey &&
              getOptionTextFn(opt, scope)}</option>
          )
        }
      })
  }

  if (useAsync) {
    return (
      <AsyncSelect id={id}
                   name={name}
                   label={label}
                   helpText={helpText}
                   isSearchable={searchable}
                   value={getKeyOfOpt(value, optionKeyName)}
                   onChange={(newValue) => onChange(
                     localChange(newValue.value))}
                   options={optionList}
                   isInsideModal={isInsideModal}
      />
    )
  } else {
    return (
      <Fragment>
        <Label name={name} label={label} helpText={helpText} forId={id}/>
        <select id={id}
                className="form-control"
                value={getKeyOfOpt(value, optionKeyName)}
                onChange={e => onChange(localChange(e.target.value))}
        >
          {optionList}
        </select>
      </Fragment>
    )
  }
}

export default DropDown
